
const colors = {
    primary: "#336599", // Top bar and highlight color
    secondary: "#336599", // Active navigation link color
    black: "#000", // Default text color
    white: "#fff", // Light text color
    navColor:"#ABABAB",
    background: "#f9f9f9",
    regButton:"#2A3342",
    bgColor:"#F4F7FB", // App/dashboard background (design pale blue, was lavender)
    // Design navy scale + gradients (replaces former purple theme)
    navyDark:"#244C77",
    navyMid:"#336599",
    navyLight:"#4A7BA8",
    navyGradient:"linear-gradient(90deg, #4A7BA8, #244C77)",
    lightFill:"#EAF1F8",
    lightText:"#333",
    lightButton:"#62c5f5",
    subText:"rgba(0, 0, 0, 0.5)",
    lightRed:"rgba(242, 83, 52, 0.34)",
    darkRed:"#F25334",
    lightGreen:"rgba(117, 193, 55, 0.34)",
    darkGreen:"#75C137",
    lightBlue:"rgba(35, 144, 255, 0.34)",
    darkblue:"#2390FF",
    footerBgColor:"#336599",
    footerColor:"#fff",
    footerSubText:"#fff",
    joinUSurl:'https://docs.google.com/forms/d/e/1FAIpQLScOCjCJ-VdediGhUt8bBtKHKFv9r2GCaoiOB7LjB0UfCqMeMA/viewform',
    registerUSurl:'https://tinyurl.com/CTSRegistration202526',
    Facebookurl:"https://www.facebook.com/CummingTamilSchool/",
    instaurl:"https://www.instagram.com/cummingtamilschool/",
    linkedinurl:"https://www.linkedin.com/",
    Twitterurl:"https://x.com/?lang=en-in",
    YouTubeurl:"https://youtube.com/@cummingtamilschool4313?si=TJi-YmYFOmKeuCYs"

  };
  
  export default colors;
  